import { throttle } from 'throttle-debounce';

export const getThrottled = <
  TFn extends (...args: any[]) => void | PromiseLike<void>,
>(
  fn: TFn,
  options: { intervalMs: number; noLeading?: boolean },
) =>
  throttle(options.intervalMs, fn, {
    noLeading: options.noLeading ?? false,
  });
